/** What a refused save means for the form, by the status the API answered with. */
import { TicketSalesCampaignApiError } from '../../../api/ticket-sales-campaigns';

import { serverErrorsToForm, type CampaignFormErrors } from './campaign-form';

export function saveErrorToForm(error: unknown): CampaignFormErrors {
  if (!(error instanceof TicketSalesCampaignApiError)) {
    return { form: 'The campaign couldn’t be saved. Check your connection and try again.' };
  }
  switch (error.status) {
    case 400: {
      const errors = serverErrorsToForm(error.fieldErrors);
      return Object.keys(errors).length > 0 ? errors : { form: error.message };
    }
    case 403:
      return { form: 'You don’t have permission to change campaigns.' };
    case 404:
      return { form: 'This campaign no longer exists. It may have been removed.' };
    default:
      return { form: 'The campaign couldn’t be saved. Try again in a moment.' };
  }
}
